(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsTimePerOperatorController', reports);

  reports.$inject = ['$scope', '$http', 'NotificationService', 'LangService'];

  function reports ($scope, $http, NotificationService, LangService) {
    var vmTimePerOperator = this;
    $scope.vmTimePerOperator = vmTimePerOperator;

    $http.get(apiUrl + '/users', {
      params: {
        role: 0
      }
    })
      .then(function ({ data, status, headers, config }) {
        vmTimePerOperator.operators = data;
      }, function ({ data }) { console.log(data) });

    vmTimePerOperator.filters = {
      operators: 'all',
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    LangService
      .getPageLabels({ 'page': 'menu.reports.timePerOperator' })
      .$promise
      .then(function (data) {
        vmTimePerOperator.labels = data.lang;
      });

    vmTimePerOperator.generate = function (downloadReport) {
      $http.get(apiUrl + '/reports/time_per_operator', {
        params: {
          filters: vmTimePerOperator.filters,
          downloadReport: downloadReport
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (data.error) {
            NotificationService.errorHandler(data, data.error);
            return;
          }

          if (downloadReport) {
            var filename = headers('Mktzap-Filename') || 'timePerOperator' + '.csv';

            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' });
            angular.element(document.body).append(anchor);

            var blob = new Blob([data], { type: 'text/csv' });
            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove();
            URL.revokeObjectURL(csvUrl);

            return;
          }

          vmTimePerOperator.dados = data;
        }, function ({ data, status, headers, config }) {
          if (status == 504) {
            $http.get(apiUrl + '/reports/time_per_operator', {
              params: {
                filters: vmTimePerOperator.filters,
                sendByEmail: true
              }
            })
              .then(function ({ data, status, headers, config }) {
                if (data.success) {
                  NotificationService.warningHandler(null, vmTimePerOperator.labels.alertProcessMail);
                }
              }, function ({ data }) {
                NotificationService.errorHandler(data, vmTimePerOperator.labels.errorReport);
              })
            return;
          }

          NotificationService.errorHandler(data, vmTimePerOperator.labels.errorReport);
        })
    }
  }
})();
